export const currencyFormat = '$0,0.00';

export const currencyWithoutDecimalFormat = '$0,0';
